import api from 'src/shared/api/axios';
import type { Member } from 'src/features/projects/types';

/** 프로젝트 멤버 목록 */
export async function apiGetProjectMembers(projectId: string): Promise<Member[]> {
    const { data } = await api.get(`/projects/${projectId}/members`);
    const v = data?.data ?? data; // { ok, data } 또는 data 바로 오는 케이스 모두 대응
    return Array.isArray(v) ? (v as Member[]) : [];
}
